import { SignalDoc } from "@megaron/docs-contracts";

export const isSignalUnread = (signal: SignalDoc): boolean => !signal.isRead;
